"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmSceneSell
 * @author xlongjiang
 * @created 2025-11-10 02:23:55
 */

const TabPanel = _tpmProductIntl.Tab.TabPanel;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmSceneSellData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$itemList = _ref.itemList,
    itemList = _ref$itemList === void 0 ? [] : _ref$itemList;
  const handleItemList = itemList.map((item, index) => {
    const _item$text = item.text,
      text = _item$text === void 0 ? '' : _item$text,
      _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$desc = item.desc,
      desc = _item$desc === void 0 ? '' : _item$desc,
      _item$listTitle = item.listTitle,
      listTitle = _item$listTitle === void 0 ? '' : _item$listTitle,
      _item$list = item.list,
      list = _item$list === void 0 ? [] : _item$list,
      _item$customerTitle = item.customerTitle,
      customerTitle = _item$customerTitle === void 0 ? '' : _item$customerTitle,
      _item$customerList = item.customerList,
      customerList = _item$customerList === void 0 ? [] : _item$customerList,
      _item$btnList = item.btnList,
      btnList = _item$btnList === void 0 ? [] : _item$btnList,
      _item$recommendTitle = item.recommendTitle,
      recommendTitle = _item$recommendTitle === void 0 ? '' : _item$recommendTitle,
      _item$recommendList = item.recommendList,
      recommendList = _item$recommendList === void 0 ? [] : _item$recommendList,
      _item$bgImg = item.bgImg,
      bgImg = _item$bgImg === void 0 ? '' : _item$bgImg;
    const handleBtnList = btnList.map((btn, key) => {
      const _btn$btnText = btn.btnText,
        btnText = _btn$btnText === void 0 ? '' : _btn$btnText,
        _btn$btnHref = btn.btnHref,
        btnHref = _btn$btnHref === void 0 ? '' : _btn$btnHref;
      const btnExtendProps = {
        'report-event': 'click_SceneSell_btn',
        'report-ext1': index,
        'report-ext2': key,
        'report-ext3': btnText || '',
        target: '_blank'
      };
      if (key === 1) {
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          href: btnHref,
          type: 'weak',
          icon: true,
          align: "center"
        }, btnExtendProps), btnText);
      }
      return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        href: btnHref,
        icon: true,
        align: "center"
      }, btnExtendProps), btnText);
    });
    const handleRecommendList = recommendList.map((item, key) => {
      const _item$title2 = item.title,
        title = _item$title2 === void 0 ? '' : _item$title2,
        _item$desc2 = item.desc,
        desc = _item$desc2 === void 0 ? '' : _item$desc2,
        _item$list2 = item.list,
        list = _item$list2 === void 0 ? [] : _item$list2,
        _item$btnText = item.btnText,
        btnText = _item$btnText === void 0 ? '' : _item$btnText,
        _item$btnHref = item.btnHref,
        btnHref = _item$btnHref === void 0 ? '' : _item$btnHref,
        _item$linkText = item.linkText,
        linkText = _item$linkText === void 0 ? '' : _item$linkText,
        _item$linkHref = item.linkHref,
        linkHref = _item$linkHref === void 0 ? '' : _item$linkHref;
      const handleBtn = () => {
        const btnExtendProps = {
          'report-event': 'click_SceneSell_recommend_btn',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': btnText || '',
          target: '_blank'
        };
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          type: 'weak',
          align: "center",
          href: btnHref,
          icon: true
        }, btnExtendProps), /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
          html: btnText
        }));
      };
      const handleLink = () => {
        const linkExtendProps = {
          'report-event': 'click_SceneSell_recommend_link',
          'report-ext1': index,
          'report-ext2': key,
          'report-ext3': linkText || '',
          target: '_blank'
        };
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Link, Object.assign({
          href: linkHref,
          icon: true
        }, linkExtendProps), linkText);
      };
      return {
        title,
        desc,
        list,
        btn: btnText && btnHref ? handleBtn() : null,
        link: linkText && linkHref ? handleLink() : null
      };
    });
    return {
      text,
      title,
      desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
        html: desc
      }) : '',
      list: listTitle || !!list.length ? {
        title: listTitle,
        data: list
      } : null,
      customer: customerTitle || !!customerList.length ? {
        title: customerTitle,
        data: customerList.map(item => ({
          img: (0, _componentUtils.doComponentsUploadEvent)(item.img || '').url
        }))
      } : null,
      btnList: !!btnList.length ? handleBtnList : null,
      recommend: recommendTitle || !!recommendList.length ? {
        text: recommendTitle,
        data: !!recommendList.length ? handleRecommendList : null
      } : null,
      bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    itemList: !!itemList.length ? handleItemList : null
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmSceneSellDa = formatTpmSceneSellData(data, {
        domains
      }),
      porintId = _formatTpmSceneSellDa.porintId,
      tag = _formatTpmSceneSellDa.tag,
      title = _formatTpmSceneSellDa.title,
      desc = _formatTpmSceneSellDa.desc,
      itemList = _formatTpmSceneSellDa.itemList;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmSceneSell`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmSceneSell', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      className: "tpm-product-intl-scene-sell__section"
    }, itemList.length <= 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.SceneSell, itemList[0]) : /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: itemList.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, itemList.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.SceneSell, item))))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}